import React from "react";
import {Container, Grid, Link, Typography, Box, Button} from "@mui/material";


import { Link as RouterLink } from "react-router-dom";

import {GetLocaleData, IsRtl, MediaQueryCheck} from "../customHook/useGlobal";

function ThePageHeader(props) {
    const staticData = {
        payTitle: {
            en: "Quick Pay",
            ar: "الدفع السريع"
        },
        rechargeTitle: {
            en: "Recharge your prepaid",
            ar: "تعبئة رصيد الدفع المسبق"
        },
        accountLbl: {
            en: "Account",
            ar: "الحساب"
        },
        changeLbl: {
            en: "Change",
            ar: "تغيير"
        },
        payTitleSuccess: {
            en: "Payment successful",
            ar: "تمت عملية الدفع بنجاح"
        },
        rechargeTitleSuccess: {
            en: "successful",
            ar: ""
        },
        referenceLbl: {
            en: "Your reference ID is:",
            ar: "رقم المرجع:"
        }
    }

    const isScreenLarge = MediaQueryCheck("lg")

    const isRtl = IsRtl()
    const locale = isRtl ? 'ar': 'en';

    const handleGTM = (e) => {
        //GTM
        window.dataLayer.push({
            event: "eventTracker",
            eventCategory: props.props.planType === "prepaid" ? "My Account Quick Recharge" : "My Account Quick Payment",
            eventAction: "Credit Card Page",
            eventLabel: props.props.planType === "prepaid" ? "Entered a prepaid number - Change" : "Entered a postpaid number - Change"
        });
    }

    const getJourneyLink = () => {
        return props.props.journeyType=="postpaid" ? "/"+locale+"/quick-pay/" : "/"+locale+"/quick-recharge/"
    }

    return (
        <>
            <Container maxWidth={false} disableGutters sx={{boxShadow: "0 2px 12px 0px rgb(0 0 0 / 10%)", py:8}}>
                <Grid container maxWidth="lg" sx={{ mx: "auto" }}>
                    <Grid item xs={12}>
                        <Box sx={{px: isScreenLarge ? "0" : "20px"}}>
                        { props.props.type === "pay" ? (
                            <>
                                <Typography gutterBottom variant="h2" component="h1">
                                    {(props.props.planType === "prepaid" && !props.props.isControlPlan) || (props.props.isControlPlan && props.props.journeyType==="prepaid") ? GetLocaleData(staticData.rechargeTitle) : GetLocaleData(staticData.payTitle)}
                                </Typography>
                                <Typography variant="body1" component="p">
                                    {props.props.planType==="prepaid"? props.props.ratePLan : GetLocaleData(staticData.accountLbl) } <strong>{props.props.msisdn}</strong>

                                    <Link component={RouterLink} to={props.props.journeyType=="postpaid" ? "/"+locale+"/quick-pay/" : "/"+locale+"/quick-recharge/"}  variant="body2" sx={{ml:2}}
                                          onClick={(e) => {
                                              handleGTM(e)
                                          }}
                                    >
                                        {GetLocaleData(staticData.changeLbl)}
                                    </Link>
                                </Typography>
                            </>) :
                            (
                                <>
                                    <Typography gutterBottom variant="h2" component="h1">
                                        {GetLocaleData(staticData.payTitleSuccess)}
                                    </Typography>
                                    <Typography variant="body1" component="p">
                                        {GetLocaleData(staticData.referenceLbl)} <strong>001125731217</strong>
                                    </Typography>
                                </>
                            )}
                        </Box>
                    </Grid>
                </Grid>

            </Container>
        </>
    );
}

export default ThePageHeader;